module.exports = __webpack_public_path__ + "fonts/Univers-LT-Std-59-Ultra-Condensed.2c26d18.otf";